import formFields from "./js/_scripts";

formFields.init();